import { lazy } from 'react';

const UserCreate = lazy(() => import('./UserCreate'));

export default UserCreate;
